import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders} from '@angular/common/http';
import { environment } from '../../environments/environment';


import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

@Injectable()
export class PartnerService {
    httpOptions: any = {
        headers: new HttpHeaders({
         'Content-Type':  'application/json',
         'Access-Control-Allow-Origin': '*'
        })
     }

    constructor(private _http: HttpClient) { }
    // Method for get employee list
    getPartners(): Observable<any> {       
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {
            "userid": loginUser.userDetail.id,
            "token": loginUser.token,
            "isforAdmin": true,
        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/getPartners", body, this.httpOptions)
            .catch(this.handleError);

    }


    // Method for get employee list
    getLaboratoryTest(): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*'
            })
        }
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {
            "userid": loginUser.userDetail.id,
            "token": loginUser.token,
            "isforAdmin": true,
        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/getPartnerProduct", body, this.httpOptions)
            .catch(this.handleError);

    }



    // Method for Save new Coupon details
    addPartner(couponForm) {       
        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');

        //let data = employee;
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = couponForm;
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/addPartners", couponForm)
            .catch(this.handleError);

    }


    // Method for Save new Coupon details
    updatePartner(couponForm) {
       
        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');
        //let data = employee;
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = couponForm;
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/updatePartner", body, this.httpOptions)
            .catch(this.handleError);
    }


    deletePartner(partnerdetails) {
      
        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');
        //let data = employee;           
        let data = partnerdetails;
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/deletePartner", body, this.httpOptions)
            .catch(this.handleError);
    }


    // Method for Save new partner product
    saveProduct(productForm) {      
        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');
        //let data = employee;    

        let data = productForm;
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/addProduct", body, this.httpOptions)
            .catch(this.handleError);
    }

    // method for update product
    updateProduct(productForm) {        
        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');
        //let data = employee;    

        let data = productForm;
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/updateProduct", body, this.httpOptions)
            .catch(this.handleError);
    }

    // Method for delete partner product
    deleteProduct(productdetails) {       
        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');
        //let data = employee;           
        let data = productdetails;
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/deleteProduct", body, this.httpOptions)
            .catch(this.handleError);
    }


    // Method for get get Partner Products WithPrice Details
    getPartnerProductsWithPriceDetails(): Observable<any> {
       
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {
            "userid": loginUser.userDetail.id,
            "token": loginUser.token,
            "isforAdmin": true,
        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/getAllProductPriceList", body, this.httpOptions)
            .catch(this.handleError);

    }

    // Add partner product

    AddPartnerProduct(productForm) {       
        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');
        //let data = employee;    

        let data = productForm;
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/addPartnerProduct", body, this.httpOptions)
            .catch(this.handleError);
    }

    // update partner product
    updatePartnerProduct(productForm) {       
        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');
        //let data = employee;    

        let data = productForm;
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/updatePartnerProduct", body, this.httpOptions)
            .catch(this.handleError);
    }

    // Method for delete partner product
    deletePartnerProduct(productdetails) {
       
        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');
        //let data = employee;           
        let data = productdetails;
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/deletePartnerProduct", body, this.httpOptions)
            .catch(this.handleError);
    }

    // Method for get partner order details

    getPartnerOrder():Observable<any>{       
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {          
            "token": loginUser.token,
            "partnerid": loginUser.userDetail.partnerId,
            
        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/getPartnerOrderDetails", body, this.httpOptions)
            .catch(this.handleError);
    }  

    getPharmacyOrder():Observable<any>{       
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {          
            "token": loginUser.token,
            "partnerid": loginUser.userDetail.partnerId,
            "isadmin":loginUser.isAdmin
        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/getPharmacyOrderDetails", body, this.httpOptions)
            .catch(this.handleError);
    }  


    getLaboratoryOrder():Observable<any>{       
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {          
            "token": loginUser.token,
            "partnerid": loginUser.userDetail.partnerId,
            "isadmin":loginUser.isAdmin
        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/getLaboratoryOrderDetails", body, this.httpOptions)
            .catch(this.handleError);
    }  

    getDiagnosticsOrder():Observable<any>{       
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {          
            "token": loginUser.token,
            "partnerid": loginUser.userDetail.partnerId,
            "isadmin":loginUser.isAdmin
        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/getDiagnosticsOrderDetails", body, this.httpOptions)
            .catch(this.handleError);
    }  

    getReferralOrder():Observable<any>{       
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {          
            "token": loginUser.token,
            "partnerid": loginUser.userDetail.partnerId,
            "isadmin":loginUser.isAdmin
        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/getReferralOrderDetails", body, this.httpOptions)
            .catch(this.handleError);
    }  




     // Method for update order deliver status product
    updateOrderDeliveryStatus(orderdetails):Observable<any> {        
        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');
        //let data = employee;           
        let data = orderdetails;
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/updateOrderDeliveryStatus", body, this.httpOptions)
            .catch(this.handleError);
    }

    getAdminOrderSummery():Observable<any>
    {
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {          
            "token": loginUser.token,
            "partnerid": loginUser.userDetail.partnerId,
            "isadmin":loginUser.isAdmin
        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/getPartnersOrderSummery", body, this.httpOptions)
            .catch(this.handleError);
    }


    getPartnerDashboardDetails():Observable<any>{       
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let data = {          
            "token": loginUser.token,
            "partnerid": loginUser.userDetail.partnerId,
            "isadmin":loginUser.isAdmin
        }
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/getPartnerUserDashboardDetails", body, this.httpOptions)
            .catch(this.handleError);
    } 


    handleError(error: Response) {
        console.log(error);
        return Observable.throw(error);
    }

    // this method for use render page




















}